module.exports = __webpack_public_path__ + "static/media/logo2.d6f88f6c.png";